export default __webpack_public_path__ + "static/media/boy.c96ae342.svg";